import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatPaginator, MatSelectChange, MatSort, MatTableDataSource, PageEvent } from '@angular/material';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { ToastrService } from 'ngx-toastr';
import beautify from 'xml-beautifier';
import { LoginService } from '../Shared/Service/login_service';
import { DashboarduiService } from '../Shared/Service/dashboardui.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { interval } from 'rxjs';
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
export class idsProductList {
  id: number;
  status: String;
  hotelName: String;
  accountingDate: any;
  pusheddate: any;
  type: any
}
@Component({
  selector: 'app-bookinglog',
  templateUrl: './bookinglog.component.html',
  styleUrls: ['./bookinglog.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class BookinglogComponent implements OnInit {
  apiresult: any;
  hotellistChannel: any;
  hotellistproperty: any;
  today = new Date();
  hotelSearchDataStatus: any;
  productType: any;
  heartBeatData: any;
  errorMsgSubscription: boolean;
  displayContent: boolean;
  errorMessage: string;
  idsProductList: idsProductList[] = [];
  dataSource: MatTableDataSource<idsProductList>
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  XMLName: any;
  ValSearchDownload: any;
  filterProperty: any;
  searchValueData: any;
  insertChecked: any;
  enableButtonReprocess: boolean = false;
  dataArray: any[];
  constructor(private apiCallIdsService: DashboarduiService, private toastr: ToastrService, private datePipe: DatePipe, public loginService: LoginService) { }
  dropdownSettings = {};
  status: any = [] = [];
  display: Boolean = false;
  lstgetcmlist1: any = [] = [];
  defaultData: any = [] = [];
  p: Number = 1;
  count: Number = 50;
  User: string;
  header: string;
  rateCode: string;
  selectedDate: any = new Date();
  selectedTOODate: any = new Date();
  isProgressing: Boolean = false;
  Pmscodevalue: any;
  PGF: any = "0";
  PGT: any = "50";
  selectedChannel: any;
  lstgetcmlist: any = []
  lstBookingCopy: any = [] = [];
  lstBooking: any = [] = [];
  // dataSource: any = [];
  totalcount: any = 0;
  pageSize = 50;
  hotellistCopy: any = [] = [];
  Val: string;
  hotellist: any = [] = [];
  allproperty: any[];
  selected: string;
  Userid: any = [];
  selectedItems: string;
  displayedColumns: string[] = ['OTA#', 'PMS#','Echotoken', 'Mode', 'Received from cm', 'Sent to pms', 'Arrival', 'Departure', 'Guest', 'OTA', 'Room type', 'Room', 'ReceivedXML','Remarks','checkboxForReprocess'];
  /* Search Field */
  dropdownSettingsDept: IDropdownSettings = {};
  selectedDeptItems: any;
  dropdownDeptData: any
  currentDateStore: any;
  storeHeartBeatValue: any;
  blinkOfflineHotel: boolean;
  todayFuture:any = new Date();
  todayFutureOneDay: any = new Date(this.todayFuture.setDate(this.todayFuture.getDate() + 1));
  ngOnInit() {
    this.ValSearchDownload = ''
    this.isProgressing = true;
    this.errorMsgSubscription = true
    this.errorMessage = "Please select property and load"
    this.displayContent = false
    this.callIDSUsersProperties();
    this.dropdownSettingsDept = {
      idField: 'pmscode',
      textField: 'pmsname',
      allowSearchFilter: true,
      singleSelection: true,
      enableCheckAll: false,
      closeDropDownOnSelection: true,
      itemsShowLimit: 7,
      noDataAvailablePlaceholderText: 'No Data Found',
      searchPlaceholderText: "Search Hotel Code / Name"
    };
  }

  callIDSUsersProperties() {
    this.Userid = localStorage.getItem("Username");
    console.log(this.Userid)
    this.apiCallIdsService.getchannelFXFN()
      .subscribe(
        data => {
          console.log('New Screen Data', data)
          //Remove duplicate data
          this.apiresult = data;
          console.log('Property 113 = ', data)

          this.hotellist = this.apiresult.filter((obj, pos, arr) => {
            return arr
              .map(mapObj => (mapObj.pmsname))
              .indexOf(obj.pmsname) == pos;
          });
          this.dropdownDeptData = this.hotellist;
          this.hotellistChannel = this.lstgetcmlist;
          this.hotellistproperty = this.hotellist;
          this.isProgressing = false;
        });


  }

  changePropertySearch() {
    if (this.selectedDeptItems) {
      if (this.selectedDeptItems.length > 0) {
        console.log('if condition')
        this.totalcount = 0
        this.Pmscodevalue = this.selectedDeptItems[0].pmscode
        console.log('pms code value = ', this.Pmscodevalue)
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property and load"
        this.displayContent = false

        var result = this.apiresult.filter((obj: { pmscode: MatSelectChange; }) => obj.pmscode == this.Pmscodevalue);
        console.log('filter record = ', result);
        this.lstgetcmlist = result;
        this.selectedChannel = this.lstgetcmlist[0].cmcode;
        // For Online Status
        this.apiCallIdsService
          .readHotelSearch(this.Pmscodevalue)
          .subscribe((data) => {
            console.log('readHotelSearch =', data)
            this.hotelSearchDataStatus = data[0].recordstatus
            this.productType = data[0].producttype
          });
        this.apiCallIdsService
          .readHeartbeat(this.Pmscodevalue)
          .subscribe((data) => {
            console.log('readHeartbeat =', data[0])
            this.heartBeatData = data[0].heartBeat

// For blinking the record
const today = new Date()
console.log('Today Date = ',today);
this.currentDateStore = today.toLocaleTimeString('it-IT')
console.log('Today Date = ',this.currentDateStore);
this.storeHeartBeatValue = this.GetParseonlyDateTimeBlink(this.heartBeatData)
var start = this.storeHeartBeatValue.split(":");
var end = this.currentDateStore.split(":");
var startDate = new Date(0, 0, 0, start[0], start[1], 0);
var endDate = new Date(0, 0, 0, end[0], end[1], 0);
var diff = endDate.getTime() - startDate.getTime();
var hours = Math.floor(diff / 1000 / 60 / 60);
diff -= hours * 1000 * 60 * 60;
var minutes = Math.floor(diff / 1000 / 60);
// console.log('minutes difference',minutes)
console.log('minutes difference', hours + ":"  + minutes)
if((hours + ":"  + minutes) > "0:30"){
  console.log('blinkOfflineHotel true')
  this.blinkOfflineHotel = true
}else{
  console.log('blinkOfflineHotel false')
  this.blinkOfflineHotel = false
}


          });
        interval(2000 * 60).subscribe(() => {
          this.heartbeatFunction();
        });
      } else {
        console.log('Else condition zero')
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property and load"
        this.displayContent = false
      }
    } else {
      console.log('Property Not Selected')
    }
  }

  heartbeatFunction() {
    this.apiCallIdsService
      .readHeartbeat(this.Pmscodevalue)
      .subscribe((data) => {
        console.log('readHeartbeat =', data[0])
        this.heartBeatData = data[0].heartBeat
      });
  }

  Search(event: any) {
    console.log('event= ', event)
    this.hotellist = this.hotellistproperty.filter((res: { pmsname: { toString: () => string; }; pmscode: { toString: () => string; } }) => {
      return res.pmsname.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase()) || res.pmscode.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase());
    });
    if (event == '') {
      this.Val = '';
      this.callIDSUsersProperties();
    }
  }

  // SearchDownload(event: any) {
  //   console.log('event= ', event)
  //   this.dataSource = this.filterProperty.filter((res: { guestName: { toString: () => string; }; pmsReservationNumber: { toString: () => string; }; crsReservationNumber: { toString: () => string; } }) => {
  //     return res.guestName.toString().toLocaleLowerCase().match(this.ValSearchDownload.toLocaleLowerCase()) || res.pmsReservationNumber.toString().toLocaleLowerCase().match(this.ValSearchDownload.toLocaleLowerCase()) || res.crsReservationNumber.toString().toLocaleLowerCase().match(this.ValSearchDownload.toLocaleLowerCase());
  //   });
  //   if (event == '') {
  //     console.log('if search')
  //     this.ValSearchDownload = '';
  //   }
  // }

  GetCommonMethodForLog(ValSearchDownload:any) {
    console.log('ValSearchDownload = ',ValSearchDownload)
    this.searchValueData = ValSearchDownload
    this.PGF = "0";
    this.PGT = "50";
    this.GetBooking()

  }

  GetBooking() {
    console.log(this.selectedChannel)
    console.log(this.Pmscodevalue)
    this.isProgressing = true;
    this.lstBooking = [];
    this.lstBookingCopy = [];
    this.selectedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
    this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
    if (this.selectedTOODate < this.selectedDate) {
      this.isProgressing = false;
      this.toastr.error('From date should be less than To date.');
    }
    else {
      this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
   
console.log('searchValueData =',this.searchValueData)
    this.apiCallIdsService.getbookinglog(this.Pmscodevalue, this.selectedChannel, this.selectedDate, this.selectedTOODate,this.PGF, this.PGT,this.searchValueData)
      .subscribe(
        data => {
                /* Manually insert ischecked as 0 */
                for (let i = 0; i < data.length; i++) {
                  data[i]['ischecked'] = 0
               }
               console.log('After insert ischecked',data);
               console.log('data.length',data.length);
          if (data.length < 1 || data[0].totalCount == 0){
            this.displayContent = false
            this.errorMsgSubscription = true
            this.errorMessage = "No Data Found"
            this.toastr.error('No Data Found');
            this.isProgressing = false;
          }else{
            this.errorMsgSubscription = false
            this.displayContent = true
            this.filterProperty = data
            this.idsProductList = data;
            this.totalcount = data[0].totalCount
            this.dataSource = new MatTableDataSource(this.idsProductList);
            console.log('dataSource = ',this.dataSource);
            this.dataSource.paginator = this.paginator;
            this.toastr.success('Data Loaded Successfully');
            this.isProgressing = false;
          }
        });
      }
  }


  pageEvent(e:any) {
    console.log('pageEvent = ', e)
    var pageIndex = e.pageIndex;
    pageIndex = pageIndex;
    console.log('pageIndex = ', pageIndex)
    this.pageSize = e.pageSize
    console.log('pageSize = ', this.pageSize)
    this.PGF = this.pageSize * pageIndex + 1;
    this.PGT = this.PGF + e.pageSize - 1;
    console.log("this.PGF", this.PGF)
    console.log("this.PGT", this.PGT)
    this.GetBooking();
  }

  GetParseonlyDateTimeBlink(d:any) {
    console.log('GetParseonlyDateTime call',d.substring(12))
    return (d.substring(12));
  }

  GetParseonlyDateTime(d) {
    if (d == "") {
      return "";
    }
    return (d.substring(0, 2)).trim() + "-" + (d.substring(2, 6)).trim() + "-" + (d.substring(6, 11)).trim() + " " + (d.substring(12, 17)).trim();


  }

  GetParseonlyDateTimeSendToPMS(d) {
    if (d == "") {
      return "";
    }
    if (d == "Two way booking sync is not applicable") {
      return "Two Way Booking Sync Is Not Applicable";
    }
    else if (d == "NotCommitExist") {
      return "Commit Not Exist";
    }
    else if (d == "DepartureDateIsLessThanTodayDate") {
      return "Departure Date Is Less Than Today Date";
    }
    else if (d == "ArrivalDateIsLessThanTodayDate") {
      return "Arrival Date Is Less Today Date"
    }
    else if (d == "RoomTypeEmpty") {
      return "Room Type Not Mapped";
    }

    else if (d == "Padding") {
      return "";
    }
    else if (d == "NotProcess") {
      return "Under Processed";
    }
    if (!Number.isNaN(Date.parse(d))) {
      return (d.substring(0, 2)).trim() + "-" + (d.substring(2, 6)).trim() + "-" + (d.substring(6, 11)).trim() + " " + (d.substring(12, 17)).trim();
    }
    else {
      return d;
    }
  }

  GetPMSResponseColor(d) {
    if (d == "") {
      return "#505050;";
    }
    if (d == "Two way booking sync is not applicable") {
      return "#ff0000"
    }
    else if (d == "NotCommitExist") {
      return "#ff0000"
    }
    else if (d == "ArrivalDateIsLessThanTodayDate") {
      return "#ff0000"
    }
    else if (d == "DepartureDateIsLessThanTodayDate") {
      return "#ff0000"
    }
    else if (d == "RoomTypeEmpty") {
      return "#ff0000d9";
    }
    else if (d == "RoomTypeEmpty") {
      return "500";
    }
    else if (d == "Padding") {
      return "#ff0000"
    }
    else if (d == "NotProcess") {
      return "#ff0000"
    }
    if (!Number.isNaN(Date.parse(d))) {
      return "#505050;";
    }

  }

  closeModalDialog() {
    this.display = false; //set none css after close dialog
  }

  showXml(xmltype: any, token: any) {

    this.status = this.LoadXML(xmltype, token);
  }
  LoadXML(xmltype: any, token: any) {
    this.isProgressing = true;
    this.apiCallIdsService.getbookingXML(this.Pmscodevalue, this.selectedChannel, token, xmltype)
      .subscribe(data => {
        if (data.length < 1) {
          this.toastr.error('No Data Found');
          this.isProgressing = false;
        } else {
          this.XMLName = "Received XML from Channel"
          const xml = beautify(data[0].xmlData);
          console.log(xml);
          this.defaultData = xml;
          this.display = true;
          this.isProgressing = false;
        }

      },
        error => {
          this.toastr.error("Falied to load requests !");
          this.isProgressing = false;
        },

      );
  }

 /* Checkbok functionality */
 GetCheckboxCheckedOrNot(ischecked: any) {
  if (ischecked == 0) {
    return false;
  }
  else {
    return true;
  }
}

checkBoxChanged(echoToken: any, e: any) {
  console.log('echoToken = ',echoToken)
  for (let i in this.idsProductList) {
    if (this.idsProductList[i]["echoToken"] == echoToken) {
      if (e.target.checked == true) {
        console.log('Checked true')
        this.idsProductList[i]["ischecked"] = 1;
      }
      if (e.target.checked == false) {
        console.log('Checked false')
        this.idsProductList[i]["ischecked"] = 0;
      }
    }
  }
  console.log('this.idsProductList after loop= ',this.idsProductList)

  this.insertChecked = this.filterProperty.filter((opt: { ischecked: any; }) => opt.ischecked)
    .map((opt: any) => opt);
    console.log('Final Result this.insertChecked= ',this.insertChecked)
    if(this.insertChecked){
      this.dataArray = []
      for(let filterPara of this.insertChecked){
        console.log('filterPara ==',filterPara)
        this.dataArray.push({
          "Echotoken": filterPara.echoToken
        })
      }
      console.log('this.dataArray == ', this.dataArray)
      if(this.dataArray.length >= 1){
        this.enableButtonReprocess = true;
      }else{
        this.enableButtonReprocess = false;
      }
      
    }
    
}

reProcess(){
  this.Userid = localStorage.getItem("Username");
  var req = {
    "PMSCode":this.Pmscodevalue,
    "UserId": this.Userid,
    "Data": this.dataArray,
  }
  console.log('Request Payload ReProcess == ',req)
  this.isProgressing = true;
  this.apiCallIdsService.getBookingLogDownloadReprocess(req)
  .subscribe(data => {
    console.log('Reprocess response =',data)
    if(data[0].status == 'Success'){
      this.toastr.success(data[0].statusDescription);
      this.dataArray = [];
      this.enableButtonReprocess = false;
      this.GetBooking()
    }else{
      this.toastr.error(data[0].statusDescription);
    }
  });
}
}
